exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flyte-panel[data-v-63ac7b8a]{height:250px;transition:width height .35 ease}.flyte-panel .card-body[data-v-63ac7b8a]{position:relative;font-size:15px}.flyte-panel .card-body p[data-v-63ac7b8a]{transition:font-size .35s ease}", ""]);

// exports
